import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import { request } from '@/service';

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
    key: 'ns_resv',
    storage: window.sessionStorage
});

export default new Vuex.Store({
    state: {
        idNo: '',
        newFriend: false,
        subHeaderShow: true,
        area: [],
        info: {},
        hasContent: true,
    },
    mutations: {
        SUB_HEADER_SHOW(state, payload) {
            state.subHeaderShow = payload;
        },
        NEW_FRIEND(state, payload) {
            state.newFriend = payload;
        },
        AREA(state, payload) {
            state.area = payload;
        },
        HAS_CONTENT(state, payload) {
            state.hasContent = payload;
        }
    },
    actions: {
        setSubHeaderShow(context, payload) {
            context.commit('SUB_HEADER_SHOW', payload);
        },
        setNewFriend(context, payload) {
            context.commit('NEW_FRIEND', payload);
        },
        setArea(context, payload) {
            context.commit('AREA', payload);
        },
        setHasContent(context, payload) {
            context.commit('HAS_CONTENT', payload);
        },
        getTokenInfo(context, payload) {
            return request({
                method: 'GET',
                api: '/auth/reserve',
                secure: true
            });
        },
        checkTokenInfoForShare(context, payload) {
            return request({
                method: 'GET',
                api: '/api/share/check/cookie',
                secure: true
            });
        }
    },
    modules: {
    },
    plugins: [vuexPersist.plugin]
});
